/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Section_Exceptions_HelpInputs */

const en_ticket_section_exceptions_help = /** @type {(inputs: Ticket_Section_Exceptions_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer-side or access exceptions. Only use when the standard flow doesn't apply.`)
};

const ja_ticket_section_exceptions_help = /** @type {(inputs: Ticket_Section_Exceptions_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客側またはアクセスの例外。標準フローが適用できない場合のみ使用してください。`)
};

const fr_ticket_section_exceptions_help = /** @type {(inputs: Ticket_Section_Exceptions_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceptions côté client ou accès. À utiliser uniquement quand le flux standard ne s'applique pas.`)
};

const de_ticket_section_exceptions_help = /** @type {(inputs: Ticket_Section_Exceptions_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunden- oder Zugangsausnahmen. Nur verwenden, wenn der Standardablauf nicht zutrifft.`)
};

/**
* | output |
* | --- |
* | "Customer-side or access exceptions. Only use when the standard flow doesn't apply." |
*
* @param {Ticket_Section_Exceptions_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_section_exceptions_help = /** @type {((inputs?: Ticket_Section_Exceptions_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Section_Exceptions_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_section_exceptions_help(inputs)
	if (locale === "ja") return ja_ticket_section_exceptions_help(inputs)
	if (locale === "fr") return fr_ticket_section_exceptions_help(inputs)
	return de_ticket_section_exceptions_help(inputs)
});